const getProgramYear = (date = new Date()) => {
  const year = date.getFullYear();
  const month = date.getMonth(); // 0 = Jan, 9 = Oct

  // If we're on or after Oct 1, program year starts this year
  const startYear = month >= 9 ? year : year - 1;

  return `${startYear}-${startYear + 1}`;
}

export default getProgramYear;